import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  ownerApi,
  type ResendOwnerInvitationPayload,
  type ResendOwnerInvitationResponse,
} from 'services/ownerApi'

export const useResendOwnerInvitation = (): UseMutationResult<
  ResendOwnerInvitationResponse,
  Error,
  ResendOwnerInvitationPayload
> => {
  return useMutation({
    mutationFn: (payload: ResendOwnerInvitationPayload) =>
      ownerApi.resendOwnerInvitation(payload),
  })
}

export type { ResendOwnerInvitationPayload, ResendOwnerInvitationResponse }
